const alert = {
  baseStyle: {
    container: {
      borderRadius: "none",
    },
  },
};

export default alert;
